(function($) {
    $.fn.suDatePicker = function() {
        if (this.length > 0) {
            const
                options = {
                    changeYear:         true,
                    dateFormat:         'dd/mm/yy',
                    datePlaceholder:    'DD/MM/YYYY',
                    maxDate:            0,
                    showMonthAfterYear: true,
                    yearRange:          '-100:c',
                    showAnim:           'fade'
                },

                i18nWelsh = {
                    closeText:          'Cwblhau',
                    currentText:        'Heddiw',
                    datePlaceholder:    'DD/MM/BBBB',
                    dayNames:           ['Dydd Sul', 'Dydd Llun', 'Dydd Mawrth', 'Dydd Mercher', 'Dydd Iau', 'Dydd Gwener', 'Dydd Sadwrn'],
                    dayNamesMin:        ['Su', 'Ll', 'Ma', 'Me', 'Ia', 'Gw', 'Sa'],
                    dayNamesShort:      ['Sul', 'Llu', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
                    monthNames:         ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr'],
                    monthNamesShort:    ['Ion', 'Chw', 'Maw', 'Ebr', 'Mai', 'Meh', 'Gor', 'Aws', 'Med', 'Hyd', 'Tac', 'Rha'],
                    nextText:           'Nesaf',
                    prevText:           'Blaenorol',
                    weekHeader:         'Wy',
                    yearSuffix:         ''
                },

                setDatePicker = () => {
                    this.each(function() {
                        const $this = $(this);

                        $this.attr('placeholder', options.datePlaceholder);
                        $this.datepicker(options);
                    });
                };

            if ($().isWelshPage()) {
                $.extend(options, i18nWelsh);
            }

            $('head').append('<link rel="stylesheet" type="text/css" href="https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css">');

            $.getScript('https://code.jquery.com/ui/1.12.0/jquery-ui.min.js').done(setDatePicker);
        }
    };
}(jQuery));
